import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["link", "section"];

  connect() {
    this.setActiveLink(); 
    window.addEventListener("scroll", this.setActiveLink.bind(this));
  }

  disconnect() {
    window.removeEventListener("scroll", this.setActiveLink.bind(this));
  }

  setActiveLink() {
    let currentIndex = this.sectionTargets.length;

    while (--currentIndex && window.scrollY + 50 < this.sectionTargets[currentIndex].offsetTop) {}

    this.linkTargets.forEach((link) => link.classList.remove("menu-active"));

    if (this.linkTargets[currentIndex]) {
      this.linkTargets[currentIndex].classList.add("menu-active");
    }
  }
}
